module.exports = __webpack_public_path__ + "static/media/nodata_icon_v1.0c89d6cd.svg";